var map = {
	"./4d-result-icon-white.svg": 373,
	"./4d-result-icon.svg": 361,
	"./Add_Icon.svg": 47,
	"./All.svg": 737,
	"./Casino.svg": 738,
	"./Dashboard_Reward.svg": 364,
	"./Fish Games.svg": 739,
	"./InCasino.svg": 376,
	"./InLottery.svg": 377,
	"./InPoker.svg": 378,
	"./InRNG.svg": 379,
	"./InSlots.svg": 380,
	"./InSports.svg": 381,
	"./InVirtual-Sports.svg": 382,
	"./IneSports.svg": 383,
	"./Lottery.svg": 740,
	"./Minus_Icon.svg": 48,
	"./Poker.svg": 741,
	"./RNG.svg": 742,
	"./Slots.svg": 743,
	"./Sports.svg": 744,
	"./account-icon.svg": 745,
	"./android-icon.svg": 746,
	"./blue-background-modern.svg": 384,
	"./bonus-report-icon.svg": 747,
	"./cash-icon.svg": 748,
	"./cash-withdrawal-icon.svg": 749,
	"./commission-report-icon.svg": 750,
	"./contact-us-icon-yellow.svg": 262,
	"./contact-us-icon.svg": 751,
	"./copy-icon.svg": 249,
	"./custom-checkbox-1-checked.svg": 185,
	"./custom-checkbox-1-unchecked.svg": 186,
	"./custom-checkbox-modern-1-checked.svg": 385,
	"./custom-checkbox-modern-1-unchecked.svg": 386,
	"./dashboard-logout.svg": 238,
	"./downline-account.svg": 752,
	"./downline-icon-white.svg": 374,
	"./downline.svg": 753,
	"./downlines-icon.svg": 362,
	"./eSports.svg": 754,
	"./game-report-icon.svg": 755,
	"./games-icon.svg": 756,
	"./goldMinus.svg": 76,
	"./goldPlus.svg": 75,
	"./heart-all-icon.svg": 757,
	"./ionic-ios-add-circle-outline.svg": 73,
	"./ionic-ios-minus-circle-outline.svg": 74,
	"./kpi-icon.svg": 263,
	"./live-chat.svg": 758,
	"./maintenance.svg": 387,
	"./money-bag.svg": 239,
	"./notification-icon-unread.svg": 367,
	"./notification-icon.svg": 368,
	"./phonebook-icon.svg": 759,
	"./point-icon.svg": 760,
	"./prize-package-icon.svg": 761,
	"./referral-icon.svg": 363,
	"./reload-icon-white.svg": 370,
	"./reload-icon.svg": 358,
	"./reports-icon-white.svg": 372,
	"./reports-icon.svg": 360,
	"./reset_password.svg": 159,
	"./result-icon.svg": 762,
	"./right-menu-contact-us-icon.svg": 243,
	"./right-menu-home-icon.svg": 763,
	"./right-menu-logout-icon.svg": 248,
	"./right-menu-notification-icon.svg": 240,
	"./right-menu-profile-icon.svg": 764,
	"./right-menu-promotion-icon.svg": 247,
	"./right-menu-ranking-event-icon.svg": 246,
	"./right-menu-referral-icon.svg": 264,
	"./right-menu-settings-icon.svg": 245,
	"./right-menu-tnc-icon.svg": 244,
	"./right-menu-video-tutorial-icon.svg": 241,
	"./right-menu-vip-icon.svg": 242,
	"./right-menu-wallet-icon.svg": 765,
	"./rollover-report-icon.svg": 766,
	"./settings-icon.svg": 365,
	"./shareholder-icon.svg": 767,
	"./star.svg": 366,
	"./ticket-icon.svg": 768,
	"./tnc-icon.svg": 369,
	"./top-up-icon.svg": 769,
	"./transfer-icon-white.svg": 371,
	"./transfer-icon.svg": 359,
	"./vid-tutorial-icon.svg": 261,
	"./wallet-stmt-icon.svg": 770,
	"./wallet.svg": 771,
	"./xmas-background-modern-lowerOpac.svg": 388,
	"./xmas-background-modern.svg": 389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 375;